import { AutogenLayoutCommissionsManagementList } from "./autogen/AutogenLayoutCommissionsManagementList";

export class CommissionsManagementList extends AutogenLayoutCommissionsManagementList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "id", sort: "asc" }];
        this.mainDataSource.search({ "status": "A" });
    }
}
